import axios from "axios";
import { path_url } from "../Config/config";

const BASE_URL =
  path_url;



/**
 * Normalizes backend error responses into a user-friendly error object or message string.
 */
const normalizeError = (error) => {
  if (error.response && error.response.data) {
    const data = error.response.data;

    // Validation failures (400) where data is a fieldName: errorMessage map
    if (data.data && typeof data.data === "object" && !Array.isArray(data.data)) {
      const fieldErrors = Object.values(data.data).join(", ");
      if (fieldErrors) return fieldErrors;
    }

    // Standard ApiResult message
    if (data.message) {
      return data.message;
    }

    if (typeof data === "string") {
      return data;
    }
  }
  return error.message || "Server is unreachable. Please try again later.";
};

/**
 * Step 1: Request OTP for password reset
 * @param {string} email
 */
export const initiatePasswordReset = async (email) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/password-reset/initiate`, {
      email,
    });
    return response.data; // ApiResult { success, message, data }
  } catch (error) {
    throw new Error(normalizeError(error));
  }
};

/**
 * Step 2: Validate OTP and receive short-lived resetToken
 * @param {string} email
 * @param {string} otp
 */
export const validateOtp = async (email, otp) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/password-reset/validate-otp`, {
      email,
      otp,
    });
    return response.data; // ApiResult { success, message, data: { resetToken } }
  } catch (error) {
    throw new Error(normalizeError(error));
  }
};

/**
 * Step 3: Set new password using resetToken header
 * @param {string} email
 * @param {string} resetToken
 * @param {string} newPassword
 */
export const updatePassword = async (email, resetToken, newPassword) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/password-reset/update-password`,
      {
        email,
        newPassword,
      },
      {
        headers: {
          "X-Reset-Token": resetToken,
        },
      }
    );
    return response.data; // ApiResult { success, message }
  } catch (error) {
    throw new Error(normalizeError(error));
  }
};
